module.exports = __webpack_public_path__ + "static/image/history/m/202311@x3.ver2_0_2.jpg?63a02159";